import { render, staticRenderFns } from "./CaseJewellersBlock.vue?vue&type=template&id=2940ac76"
import script from "./CaseJewellersBlock.vue?vue&type=script&lang=js"
export * from "./CaseJewellersBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports